<template>
  <div>
    <div class="flex flex-row">
      <span class="flex flex-row">
        <img src="./mail-forward.svg" alt="" />
        <span class="ml-1"> Actions </span>
      </span>
      <span class="mx-3" style="color: #eeeeee">|</span>
      <span class="flex flex-row">
        <img src="./copy.svg" alt="" />
        <span class="ml-1">Forms/Documents</span>
      </span>
    </div>
    <div>

    <div class="flex flex-row rounded my-3 justify-between px-2 border border-blue-300  h-12">
      <span class="flex my-auto flex-row">
        <img src="./copy.svg" alt="" />
        <span class="ml-1"> Create new functions </span>
      </span>
      <span class="flex flex-row">
        <img @click="editFunction" src="@/assets/images/icons/edit-box.svg" alt="" />
        <img src="@/assets/images/icons/delete-icon.svg" alt="" />
      </span>
    </div>
    <div class="flex flex-row rounded my-3 justify-between px-2 border border-blue-300  h-12">
      <span class="flex my-auto flex-row">
        <img src="./mail-forward.svg" alt="" />
        <span class="ml-1"> Delete new functions </span>
      </span>
      <span class="flex flex-row">
        <img src="@/assets/images/icons/edit-box.svg" alt="" />
        <img src="@/assets/images/icons/delete-icon.svg" alt="" />
      </span>
    </div>
    <div class="flex flex-row rounded my-3 justify-between px-2 border border-blue-300  h-12">
      <span class="flex my-auto flex-row">
        <img src="./mail-forward.svg" alt="" />
        <span class="ml-1"> Edit an existing function. </span>
      </span>
      <span class="flex flex-row">
        <img @click="editFunction" src="@/assets/images/icons/edit-box.svg" alt="" />
        <img src="@/assets/images/icons/delete-icon.svg" alt="" />
      </span>
    </div>
    <div class="flex flex-row rounded my-3 justify-between px-2 border border-blue-300  h-12">
      <span class="flex my-auto flex-row">
        <img src="./copy.svg" alt="" />
        <span class="ml-1"> Add people </span>
      </span>
      <span class="flex flex-row">
        <img src="@/assets/images/icons/edit-box.svg" alt="" />
        <img src="@/assets/images/icons/delete-icon.svg" alt="" />
      </span>
    </div>
    <div class="flex flex-row rounded my-3 justify-between px-2 border border-blue-300  h-12">
      <span class="flex my-auto flex-row">
        <img src="./mail-forward.svg" alt="" />
        <span class="ml-1"> Edit a job level. </span>
      </span>
      <span class="flex flex-row">
        <img src="@/assets/images/icons/edit-box.svg" alt="" />
        <img src="@/assets/images/icons/delete-icon.svg" alt="" />
      </span>
    </div>
    </div>
    <hr style="color: #eeeeee">
  </div>
</template>

<script>
export default {
  methods:{
     editFunction(){

            this.$router.push({name:'editApprovalWorkFlow'})
        }
  }
};
</script>

<style>
</style>